export const Home = () => {
  return (
    <>
      <svg
        width="44"
        height="42"
        viewBox="0 0 44 42"
        fill="#3247D1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 41.4773V13.8258L21.7742 0L43.5484 13.8258V41.4773H27.2177V25.3472H16.3306V41.4773H0ZM5.44355 36.8687H10.8871V20.7386H32.6613V36.8687H38.1048V16.1301L21.7742 5.76073L5.44355 16.1301V36.8687Z"
          fill=""
        />
      </svg>
    </>
  );
};

export const Location = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 512 512"
      >
        <g>
          <path
            fill="#ffffff"
            fill-rule="evenodd"
            d="M256 8.5c93.703 0 169.659 75.956 169.659 169.66C425.659 329.557 256 463.344 256 463.344S86.34 329.557 86.34 178.16C86.34 84.456 162.296 8.5 256 8.5zm-71.386 409.17c-67.925 6.686-115.725 22.629-115.725 41.234 0 24.629 83.771 44.596 187.11 44.596 103.338 0 187.11-19.967 187.11-44.596 0-18.605-47.8-34.549-115.726-41.234-22.492 24.379-45.415 45.57-71.385 66.051-25.968-20.481-48.893-41.672-71.384-66.051zm141.007-184.9c-4.466-34.388-34.067-61.173-69.621-61.173s-65.155 26.785-69.621 61.173a7.97 7.97 0 0 0 7.934 9.03h123.375a7.97 7.97 0 0 0 7.933-9.03zM256 85.711c-20.955 0-37.942 16.987-37.942 37.942 0 20.956 16.987 37.943 37.942 37.943s37.942-16.987 37.942-37.943c0-20.954-16.987-37.942-37.942-37.942zm0-33.773c-69.74 0-126.275 56.536-126.275 126.275 0 69.74 56.535 126.277 126.275 126.277 69.739 0 126.275-56.537 126.275-126.277 0-69.739-56.536-126.275-126.275-126.275z"
            data-original="#1980f2"
          ></path>
        </g>
      </svg>
    </>
  );
};

export const Task = () => {
  return (
    <>
      <svg
        width="369"
        height="445"
        viewBox="0 0 369 445"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M279.94 424.54C317.611 424.54 348.15 394.001 348.15 356.33C348.15 318.659 317.611 288.12 279.94 288.12C242.269 288.12 211.73 318.659 211.73 356.33C211.73 394.001 242.269 424.54 279.94 424.54Z"
          fill="white"
          stroke="#231F20"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M73.19 60.11H35.23C33.7 60.11 31.47 60.35 29.18 61.54C22.7 64.92 21.78 72.8 21.7 73.64C21.74 176.12 21.78 278.59 21.81 381.07C21.98 382.27 22.63 385.87 25.68 388.91C29.48 392.7 34.23 392.87 35.24 392.88H200.75C197.62 385.56 186.09 356.24 198.39 323.58C204.84 306.45 215.29 295.18 221.94 289.1C228.17 284.5 237.19 278.91 248.94 274.75C257.19 271.83 264.7 270.34 270.85 269.58V73.64C270.85 72.76 270.71 67.58 266.45 63.67C262.73 60.26 258.36 60.12 257.31 60.11H219.35"
          fill="white"
        />
        <path
          d="M1.77996 381.46C1.73996 380.76 1.70996 380.06 1.70996 379.36C1.71996 380.06 1.74996 380.76 1.77996 381.46Z"
          fill="white"
        />
        <path
          d="M290.86 73.64V269.8C287.29 269.34 283.63 269.11 279.93 269.11C276.86 269.11 273.84 269.27 270.86 269.58V73.64C270.86 66.18 264.79 60.11 257.32 60.11H219.36V40.11H257.32C275.81 40.11 290.86 55.15 290.86 73.64Z"
          fill="white"
          stroke="#231F20"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M21.82 381.07C21.75 380.51 21.71 379.94 21.71 379.36V296.96L21.73 379.36C21.73 379.93 21.76 380.52 21.83 381.07H21.82Z"
          fill="white"
          stroke="#231F20"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M29.9799 391.81C29.1799 391.48 28.4099 391.07 27.6899 390.57C28.3999 391.06 29.1799 391.47 29.9799 391.81Z"
          fill="white"
          stroke="#231F20"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M213.59 412.88H35.2499C34.7899 412.88 34.3199 412.87 33.8599 412.85C33.8199 412.85 33.7599 412.85 33.7199 412.84C33.5499 412.84 33.3799 412.83 33.2099 412.81C32.8099 412.8 32.4099 412.77 32.0099 412.72C31.9099 412.71 31.7999 412.71 31.6999 412.69C31.2899 412.65 30.8599 412.59 30.4399 412.53C30.2999 412.52 30.1599 412.49 30.0299 412.46C29.5199 412.39 29.0099 412.29 28.4999 412.19H28.4699C27.9799 412.09 27.4999 411.98 27.0099 411.85C26.8999 411.82 26.7999 411.81 26.6999 411.76C26.2399 411.65 25.7899 411.52 25.3399 411.37C25.3099 411.37 25.2999 411.37 25.2799 411.36C24.7799 411.2 24.2799 411.03 23.7799 410.85C23.6899 410.82 23.6199 410.79 23.5399 410.76C23.1399 410.62 22.7399 410.46 22.3399 410.29C22.2799 410.26 22.2099 410.23 22.1499 410.2C21.6599 410 21.1899 409.79 20.7199 409.56C20.2199 409.33 19.7499 409.09 19.2599 408.82C18.8599 408.61 18.4599 408.38 18.0599 408.13C17.6999 407.92 17.3499 407.69 16.9999 407.46C16.6699 407.26 16.3599 407.05 16.0399 406.82C16.0099 406.81 15.9799 406.78 15.9499 406.76C15.4499 406.42 14.9499 406.05 14.4599 405.66C14.3999 405.62 14.3499 405.57 14.2999 405.53C14.2699 405.52 14.2599 405.49 14.2299 405.47C14.2199 405.46 14.1999 405.44 14.1899 405.44C14.1599 405.41 14.1199 405.38 14.0899 405.35C13.9299 405.21 13.7799 405.08 13.6199 404.95C13.3899 404.76 13.1799 404.56 12.9599 404.38C12.7599 404.21 12.5599 404.02 12.3599 403.84C12.0699 403.58 11.7999 403.31 11.5299 403.04C10.3899 401.9 9.32994 400.68 8.36994 399.38C8.10994 399.04 7.85994 398.68 7.59994 398.32C7.10994 397.59 6.63994 396.86 6.19994 396.11C5.98994 395.72 5.76994 395.34 5.55994 394.95C4.01994 392.04 2.89994 388.86 2.26994 385.52C2.00994 384.18 1.83994 382.82 1.75994 381.43C1.72994 380.73 1.69994 380.03 1.69994 379.33V296.93L1.68994 73.62C1.68994 55.13 16.7299 40.09 35.2199 40.09H73.1799V60.09H35.2199C27.7599 60.09 21.6899 66.16 21.6899 73.62V379.33C21.6899 379.92 21.7299 380.49 21.7999 381.04C21.8399 381.33 21.8899 381.61 21.9299 381.88C21.9899 382.15 22.0399 382.42 22.1199 382.69C22.1799 382.93 22.2499 383.18 22.3299 383.4C22.3699 383.57 22.4299 383.73 22.4999 383.9C22.5699 384.13 22.6599 384.36 22.7599 384.57C23.4499 386.2 24.4499 387.66 25.6699 388.87C25.9699 389.18 26.2799 389.47 26.6099 389.74H26.6199C26.9499 390.03 27.2899 390.28 27.6499 390.53H27.6599C28.3699 391.03 29.1499 391.44 29.9499 391.77C31.5599 392.46 33.3499 392.84 35.2199 392.84H200.73C204.09 400.1 208.42 406.83 213.56 412.84L213.59 412.88Z"
          fill="white"
          stroke="#231F20"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M233.17 212.54H59.3899C56.6299 212.54 54.3899 210.3 54.3899 207.54C54.3899 204.78 56.6299 202.54 59.3899 202.54H233.17C235.93 202.54 238.17 204.78 238.17 207.54C238.17 210.3 235.93 212.54 233.17 212.54Z"
          fill="#231F20"
        />
        <path
          d="M233.17 161.37H59.3899C56.6299 161.37 54.3899 159.13 54.3899 156.37C54.3899 153.61 56.6299 151.37 59.3899 151.37H233.17C235.93 151.37 238.17 153.61 238.17 156.37C238.17 159.13 235.93 161.37 233.17 161.37Z"
          fill="#231F20"
        />
        <path
          d="M233.17 110.52H59.3899C56.6299 110.52 54.3899 108.28 54.3899 105.52C54.3899 102.76 56.6299 100.52 59.3899 100.52H233.17C235.93 100.52 238.17 102.76 238.17 105.52C238.17 108.28 235.93 110.52 233.17 110.52Z"
          fill="#231F20"
        />
        <path
          d="M233.17 263.95H59.3899C56.6299 263.95 54.3899 261.71 54.3899 258.95C54.3899 256.19 56.6299 253.95 59.3899 253.95H233.17C235.93 253.95 238.17 256.19 238.17 258.95C238.17 261.71 235.93 263.95 233.17 263.95Z"
          fill="#231F20"
        />
        <path
          d="M186.62 315.36H59.3899C56.6299 315.36 54.3899 313.12 54.3899 310.36C54.3899 307.6 56.6299 305.36 59.3899 305.36H186.62C189.38 305.36 191.62 307.6 191.62 310.36C191.62 313.12 189.38 315.36 186.62 315.36Z"
          fill="#231F20"
        />
        <path
          d="M163.21 366.76H59.3999C56.6399 366.76 54.3999 364.52 54.3999 361.76C54.3999 359 56.6399 356.76 59.3999 356.76H163.21C165.97 356.76 168.21 359 168.21 361.76C168.21 364.52 165.97 366.76 163.21 366.76Z"
          fill="#231F20"
        />
        <path
          d="M290.86 269.8C287.29 269.34 283.63 269.11 279.93 269.11C276.86 269.11 273.84 269.27 270.86 269.58C227.02 274.14 192.72 311.29 192.72 356.32C192.72 369.36 195.61 381.75 200.76 392.88C204.12 400.14 208.45 406.87 213.59 412.88C229.59 431.64 253.4 443.55 279.93 443.55C328.03 443.55 367.16 404.42 367.16 356.32C367.16 311.93 333.83 275.19 290.86 269.79V269.8ZM279.93 423.56C266.53 423.56 254.06 419.65 243.57 412.89C235.54 407.72 228.7 400.89 223.51 392.89C216.67 382.36 212.71 369.82 212.71 356.33C212.71 322.29 238.01 294.16 270.85 289.73C273.81 289.32 276.85 289.12 279.92 289.12C283.65 289.12 287.29 289.42 290.85 290.01C322.78 295.24 347.15 322.95 347.15 356.34C347.15 393.47 317.05 423.57 279.92 423.57L279.93 423.56Z"
          fill="white"
          stroke="#231F20"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M325.21 339.3L290.84 373.69L277.01 387.52C275.14 389.39 272.6 390.45 269.94 390.45C268.6 390.45 267.28 390.18 266.07 389.66C264.88 389.17 263.8 388.45 262.87 387.52L234.67 359.32C230.77 355.42 230.77 349.08 234.67 345.18C238.58 341.28 244.91 341.28 248.81 345.18L269.94 366.31L290.85 345.4L311.06 325.17C314.97 321.27 321.3 321.27 325.2 325.17C329.11 329.08 329.11 335.41 325.2 339.31L325.21 339.3Z"
          fill="white"
          stroke="#231F20"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M210.13 25.4836L174.32 25.2679C171.96 11.5658 160.29 1.13 146.28 1.13C132.27 1.13 120.59 11.5658 118.24 25.2679L82.4299 25.4836C77.3399 25.5144 73.2 29.7873 73.2 35.0258V67.2678C73.2 72.5371 77.37 76.81 82.49 76.81H210.09C215.2 76.81 219.38 72.5371 219.38 67.2678V35.0258C219.38 29.7873 215.24 25.5144 210.15 25.4836H210.13ZM156.13 41.1681C153.59 43.6949 150.1 45.2459 146.27 45.2459C142.44 45.2459 138.96 43.6949 136.41 41.1681C133.71 38.5078 132.04 34.7895 132.04 30.6501C132.04 22.5665 138.41 16.0339 146.27 16.0339C154.13 16.0339 160.5 22.5665 160.5 30.6501C160.5 34.7895 158.83 38.5181 156.13 41.1681Z"
          fill="white"
          stroke="#231F20"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M146.28 44.36C153.184 44.36 158.78 38.3158 158.78 30.86C158.78 23.4042 153.184 17.36 146.28 17.36C139.376 17.36 133.78 23.4042 133.78 30.86C133.78 38.3158 139.376 44.36 146.28 44.36Z"
          fill="white"
          stroke="#231F20"
          stroke-miterlimit="10"
        />
      </svg>
    </>
  );
};

export const Earnings = () => {
  return (
    <>
      <svg
        width="125"
        height="81"
        viewBox="0 0 125 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M91.6799 18.17L89.6899 12.2L82.1999 14.7C83.3299 17.95 87.5299 19.48 91.6799 18.18V18.17ZM105.91 43.03V36.73H98.0099C98.0499 40.17 101.56 42.95 105.91 43.03ZM34.2499 36.77H26.2499V42.99C30.6199 42.95 34.1499 40.2 34.2499 36.77ZM26.2499 65.14V71.44H34.1499C34.1099 68 30.6099 65.22 26.2499 65.14ZM20.8799 75.28H93.0499V52.3H111.28V32.89H20.8799V75.28ZM67.2499 60.68C70.4499 59.97 70.5999 57.12 67.2499 55.94V60.68ZM65.0899 46.12C62.7599 46.88 62.8299 49.12 65.0899 49.91V46.12ZM74.6099 47.6L69.0999 48.48C68.6399 47.3 68.3799 46.81 67.2499 46.2V50.48C69.2699 51.02 70.8299 51.57 71.9499 52.15C77.3199 54.93 75.7499 62.31 70.3299 64.07C69.4899 64.34 68.4699 64.5 67.2499 64.55V67.35H65.0899V64.55C60.7299 64.17 57.7199 62.51 56.9099 57.97L62.8899 57.27C63.1899 58.92 63.5399 59.78 65.0899 60.54V55.32C63.0999 54.77 61.6799 54.29 60.8499 53.89C57.2099 52.13 56.7599 47.02 59.6099 44.28C60.8399 43.1 62.6699 42.45 65.0899 42.32V40.86H67.2499V42.32C70.8299 42.54 73.7599 43.85 74.5999 47.62L74.6099 47.6ZM66.0899 71.44C56.5099 71.44 48.7399 63.67 48.7399 54.09C48.7399 44.51 56.5099 36.74 66.0899 36.74C75.6699 36.74 83.4399 44.51 83.4399 54.09C83.4399 63.67 75.6699 71.44 66.0899 71.44ZM93.0599 80.45H15.3299V27.72H116.83V52.3H113.88V30.51H18.2799V77.67H93.0499V80.45H93.0599ZM122.12 73.68H98.2699C95.4699 73.68 95.4699 68.78 98.2699 68.78H122.12C124.92 68.78 124.92 73.68 122.12 73.68ZM122.12 66.91H98.2699C95.4699 66.91 95.4699 62.02 98.2699 62.02H122.12C124.92 62.02 124.92 66.91 122.12 66.91ZM122.12 60.14H98.2699C95.4699 60.14 95.4699 55.25 98.2699 55.25H122.12C124.92 55.25 124.92 60.14 122.12 60.14ZM122.12 80.46H98.2699C95.4699 80.46 95.4699 75.57 98.2699 75.57H122.12C124.92 75.57 124.92 80.46 122.12 80.46ZM12.0499 65.72L0.909912 32.28L12.0499 28.57V31.5L5.81991 33.57L4.58991 33.98L4.96991 35.11L12.0499 56.38V65.71V65.72ZM52.0299 24.76C55.6499 23.58 59.3899 23.66 62.7599 24.76H99.5399L93.5799 6.87L39.8599 24.76H52.0199H52.0299ZM23.4999 24.76L97.2099 0.190002L105.38 24.73H102.27L95.6599 4.89L95.2799 3.76L94.0499 4.17L32.2999 24.73H23.4899L23.4999 24.76ZM12.0399 34.02L7.79991 35.43L12.0399 48.16V34.02Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const DelBtn = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM14.71 13.29L13.3 14.7L10 11.41L6.71 14.71L5.29 13.29L8.59 10L5.29 6.71L6.71 5.29L10 8.59L13.29 5.3L14.7 6.71L11.41 10L14.71 13.29Z"
          fill="#666666"
        />
      </svg>
    </>
  );
};


export const Profile = () => {
  return (
    <>
    <svg width="396" height="394" viewBox="0 0 396 394" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M198 192.36C251.019 192.36 294 149.38 294 96.3604C294 43.341 251.019 0.360352 198 0.360352C144.981 0.360352 102 43.341 102 96.3604C102 149.38 144.981 192.36 198 192.36Z" fill="black"/>
<path d="M395.068 345.639C386.819 312.699 367.903 282.547 340.593 258.805C333.965 252.971 326.781 247.644 319.121 242.88C284.237 219.93 241.717 207.677 198.111 208.006C144.791 207.767 93.5259 226.027 55.4956 258.805C28.1854 282.547 9.27002 312.699 1.02087 345.639C-0.412957 351.464 -0.335504 357.497 1.2475 363.292C2.8305 369.086 5.87856 374.495 10.1663 379.117C14.6067 383.839 20.1984 387.627 26.5295 390.202C32.8605 392.777 39.7696 394.074 46.7478 393.997H349.473C356.472 394.001 363.382 392.623 369.692 389.967C376.001 387.311 381.548 383.444 385.922 378.653C390.133 374.084 393.137 368.754 394.719 363.046C396.3 357.338 396.419 351.393 395.068 345.639Z" fill="black"/>
</svg>
    </>
  )
}

export const Index = () => {
  return (
    <>
    
    </>
  )
}


